var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rtx-login"},[_c('div',{staticClass:"iframe-warp"},[_c('iframe',{attrs:{"scrolling":"no","width":"450","height":"400","frameborder":"0","allowtransparency":"true","src":_vm.setSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }